'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _util = require('@arreeba/ristoranti-lib/lib/util');

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _cart = require('@arreeba/ristoranti-lib/lib/cart');

var _cart2 = _interopRequireDefault(_cart);

var _payment = require('@arreeba/ristoranti-lib/lib/payment');

var _payment2 = _interopRequireDefault(_payment);

var _time = require('../helpers/time');

var _time2 = _interopRequireDefault(_time);

var _voucher = require('../helpers/voucher');

var _voucher2 = _interopRequireDefault(_voucher);

var _constants = require('../constants');

var _location = require('../helpers/location');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var formatDate = function formatDate(date, time) {
  if (time === _constants.DELIVERY_TIME_ASAP) {
    return new Date().toISOString();
  }
  return [_time2.default.formatISO(date), _time2.default.toUTCTime(time)].join('T');
};

exports.default = {
  loadMenu: function loadMenu(api, appId, restaurantId, orderAction) {
    var query = 'query {\n      app(id: "' + appId + '") {\n        menu(restaurant: "' + restaurantId + '") {\n          id\n          categories {\n            name\n            description\n            items {\n              id\n              name\n              description\n              price\n              available\n              modifiers {\n                id\n                name\n                instruction\n                min_selection_points\n                max_selection_points\n                price_strategy\n                items {\n                  id\n                  name\n                  description\n                  price\n                  available\n                }\n              }\n            }\n          }\n        }\n      }\n    }';

    var queryName = 'loadMenu';
    return (0, _util.wrapAction)(orderAction, 'app', 'loadMenu', api.fetch(query, {}, queryName));
  },
  deliveryAddressCheck: function deliveryAddressCheck(api, appId, data, orderAction) {
    var _data$geometry$locati = data.geometry.location,
        lat = _data$geometry$locati.lat,
        lng = _data$geometry$locati.lng;


    var query = '\n      query {\n        app(id: "' + appId + '") {\n          merchant {\n            deliversAt(lat: ' + lat + ', lng: ' + lng + ') {\n              id\n              targetDeliveryArea {\n                id\n                offset\n                threshold\n                costs {\n                  cost\n                  threshold\n                }\n              }\n            }\n          }\n        }\n      }\n    ';

    var queryName = 'deliveryAddressCheck';
    return (0, _util.wrapAction)(orderAction, 'app[0].merchant.deliversAt', 'deliveryAddressCheck', api.fetch(query, {}, queryName));
  },
  updateDeliveryAddress: function updateDeliveryAddress(api, data, orderAction) {

    return (0, _util.wrapAction)(orderAction, 'address', 'deliveryAddressUpdate', (0, _location.coordinatesFromAddress)(data));
  },
  createOrder: function createOrder(api, appId, data, orderAction) {
    var _data$order = data.order,
        cart = _data$order.cart,
        deliveryAddress = _data$order.deliveryAddress,
        deliveryAddressExtraInfo = _data$order.deliveryAddressExtraInfo,
        deliveryData = _data$order.deliveryData,
        deliveryLocation = _data$order.deliveryLocation,
        targetRestaurant = _data$order.targetRestaurant,
        orderType = _data$order.orderType,
        orderDate = _data$order.orderDate,
        deliveryDate = _data$order.deliveryDate,
        deliveryTime = _data$order.deliveryTime,
        selectedVoucher = _data$order.selectedVoucher,
        sourceType = _data$order.sourceType,
        isAsap = _data$order.isAsap;

    // for unhandled payment

    var cashAmount = data.cashAmount;

    var extraCosts = data.order.extraCosts[orderType] || [];

    var order = _extends({
      app: appId,
      items: _cart2.default.serialize(cart),
      extraCosts: extraCosts
    }, _lodash2.default.pick(deliveryData, ['phoneNumber', 'email', 'extraInfo']), {
      date: !orderDate ? formatDate(deliveryDate, deliveryTime) : orderDate // TODO use only orderDate
    });

    var userVouchers = _lodash2.default.filter(data.userVouchers, function (x) {
      var threshold = x.constraints.threshold || 0;
      // voucher instances filterd by modules and threshold
      if (order.items.length === 0) {
        return _voucher2.default.isVoucherUsable(x);
      }
      return _voucher2.default.isVoucherUsable(x) && _cart2.default.total(cart, order.extraCosts) >= threshold;
    });

    if (isAsap) {
      order.asap = true;
    }

    if (deliveryAddressExtraInfo) {
      order.addressInfo = deliveryAddressExtraInfo;
    }

    if (orderType === _constants.ORDER_TYPE_DELIVERY) {
      order.location = deliveryLocation.geometry.location;
      order.address = _extends({}, deliveryAddress, _lodash2.default.pick(deliveryData, ['street_number', 'citofono']));
      order.restaurant = targetRestaurant;
      order.name = data.user.name;
      if (data.order.deliveryAreaId) {
        order.targetDeliveryArea = data.order.deliveryAreaId;
      }
      order.type = (0, _util.serializeEnum)('DELIVERY');
    } else {
      order.name = deliveryData.name;
      order.restaurant = targetRestaurant;
      order.type = (0, _util.serializeEnum)('TAKEAWAY');
    }

    // serialize sourcType enum
    order.sourceType = (0, _util.serializeEnum)(sourceType);

    order.total = _voucher2.default.cartTotalWithVoucher(cart, extraCosts, selectedVoucher, userVouchers);

    // apply voucher if needed
    if (selectedVoucher !== _constants.ORDER_NO_VOUCHER) {
      var voucherData = _voucher2.default.getVoucherWithId(userVouchers, selectedVoucher);
      if (voucherData) {
        order.extraCosts = [].concat(_toConsumableArray(extraCosts), [_cart2.default.extraCostFromVoucher(voucherData, cart)]);
        order.voucher = selectedVoucher;
      }
    }

    order.total = _cart2.default.total(cart, order.extraCosts);
    order.extraCosts = order.extraCosts.map(function (c) {
      return _extends({}, c, {
        type: (0, _util.serializeEnum)(c.type)
      });
    });

    // stripe payment with saved credit card (before SCA) or nexi payments with saved cardId (id contratto)
    if (data.cardId) {
      order.paymentType = (0, _util.serializeEnum)('CREDIT_CARD');
      var query = '\n        mutation {\n          storeOrder(' + (0, _util.serializeForMutation)(order) + ' creditCardId: "' + data.cardId + '" ) {\n            id\n            total\n            status\n          }\n        }\n      ';

      var queryName = 'storeOrder';
      return (0, _util.wrapAction)(orderAction, queryName, 'storeOrder', api.fetch(query, {}, queryName));
    }

    // stripe payments with new credit card (before SCA)
    if (data.stripeToken) {
      order.paymentType = (0, _util.serializeEnum)('CREDIT_CARD');
      var _query = '\n        mutation {\n          storeOrder(' + (0, _util.serializeForMutation)(order) + ' creditCardToken: "' + data.stripeToken + '" ) {\n            id\n            total\n            status\n          }\n        }\n      ';

      var _queryName = 'storeOrder';
      return (0, _util.wrapAction)(orderAction, _queryName, 'storeOrder', api.fetch(_query, {}, _queryName));
    }

    // stripe payment with new or saved credit card
    // both handled with stripe payment intent api that support SCA
    if (data.stripePaymentIntentId) {
      order.paymentType = (0, _util.serializeEnum)('CREDIT_CARD');

      var _query2 = '\n        mutation {\n          storeOrder(\n            ' + (0, _util.serializeForMutation)(order) + ' \n            stripePaymentIntentId: "' + data.stripePaymentIntentId + '",\n          ) {\n            id\n            total\n            status\n          }\n        }\n      ';

      var _queryName2 = 'storeOrder';
      return (0, _util.wrapAction)(orderAction, _queryName2, 'storeOrder', api.fetch(_query2, {}, _queryName2));
    }

    // nexi payments with new credit card
    if (data.nexi) {
      order.paymentType = (0, _util.serializeEnum)('CREDIT_CARD');

      var _query3 = '\n        mutation {\n          storeOrder(\n            ' + (0, _util.serializeForMutation)(order) + ' \n            xpayCodiceTransazione: "' + data.xpayCodiceTransazione + '",\n            xpayEsito: "' + data.xpayEsito + '",\n            xpayIdOperazione: "' + data.xpayIdOperazione + '",\n            xpayMac: "' + data.xpayMac + '",\n            xpayTimeStamp: "' + data.xpayTimeStamp + '",\n            xpayNonce: "' + data.xpayNonce + '",\n            saveCreditCard: ' + data.saveCreditCard + ',\n          ) {\n            id\n            total\n            status\n          }\n        }\n      ';

      var _queryName3 = 'storeOrder';
      return (0, _util.wrapAction)(orderAction, _queryName3, 'storeOrder', api.fetch(_query3, {}, _queryName3));
    }

    // unhandled payment
    if (!data.card && !data.nexi) {
      order.paymentType = (0, _util.serializeEnum)('UNHANDLED');
      order.cashAmount = cashAmount;
      var _query4 = '\n        mutation {\n          storeOrder(' + (0, _util.serializeForMutation)(order) + ') {\n            id\n            total\n            status\n          }\n        }\n      ';

      var _queryName4 = 'storeOrder';
      return (0, _util.wrapAction)(orderAction, _queryName4, 'storeOrder', api.fetch(_query4, {}, _queryName4));
    }

    // credit card payment
    order.paymentType = (0, _util.serializeEnum)('CREDIT_CARD');

    return _payment2.default.stripeCreateCardToken(orderAction, data.card).then(function (token) {
      if (!token) {
        return;
      }
      var query = '\n          mutation {\n            storeOrder(' + (0, _util.serializeForMutation)(order) + ' creditCardToken: "' + token + '" ) {\n              id\n              total\n              status\n            }\n          }\n        ';

      var queryName = 'storeOrder';
      (0, _util.wrapAction)(orderAction, queryName, 'storeOrder', api.fetch(query, {}, queryName));
    });
  },
  updateCurrentOrder: function updateCurrentOrder(api, appId, orderId, orderAction) {
    var query = '\n      {\n        app(id:"' + appId + '") {\n          orders(id:"' + orderId + '") {\n            status\n            confirmation {\n              date\n            }\n          }\n        }\n      }\n    ';

    var queryName = 'updateCurrentOrder';
    // we don't really give a shit about failure and fetching
    return api.fetch(query, {}, queryName).then(function (data) {
      orderAction.updateCurrentOrder(_lodash2.default.property('data.app[0].orders[0]')(data));
    });
  },
  orderFetchExtraCosts: function orderFetchExtraCosts(api, appId, _ref, orderAction) {
    var total = _ref.total,
        targetDeliveryArea = _ref.targetDeliveryArea,
        targetRestaurant = _ref.targetRestaurant;

    var query = '\n      {\n        app(id:"' + appId + '") {\n          merchant{\n            orderExtraCosts(\n              total:' + total + ',\n              targetDeliveryArea:"' + targetDeliveryArea + '"\n              restaurant:"' + targetRestaurant + '"\n            ) {\n              label\n              amount\n              type\n            }\n          }\n        }\n      }\n    ';

    var queryName = 'orderFetchExtraCosts';
    (0, _util.wrapAction)(orderAction, 'app[0].merchant.orderExtraCosts', 'orderFetchExtraCosts', api.fetch(query, {}, queryName));
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/@arreeba/ristoranti-frontend-lib/lib/services/order.js
// module id = 200
// module chunks = 0